import { lazy } from "react";
import Loadable from "../layouts/loader/Loadable";
import { ProtectEmployeeRoute } from "../components/ProtectRoute";
// Admin Layout
const AdminLayout = Loadable(lazy(() => import("../layouts/AdminLayout")));
// OnBoarding KYC
const AddDocumentKyc = Loadable(lazy(() => import("../views/profiles/addDocumentKyc")));

const employeeRouter = {
  path: "/employee",
  key: 8,
  element: <ProtectEmployeeRoute Component={AdminLayout} />,
  children: [
    // Onboarding KYC
    {
      key: 1,
      path: "addDocumentKyc",
      name: "addDocumentKyc",
      element: <AddDocumentKyc />,
    },
  ],
};

export default employeeRouter;
